import { withTranslation } from "react-i18next";
import ChecklistItem from './ChecklistItem';

export default withTranslation()(ChecklistItem);